import { Button } from '../../../../ui/Button/Button';

interface RunAnalysisButtonProps {
  onClick: () => void;
  disabled: boolean;
  canManage: boolean;
}

export function RunAnalysisButton({ onClick, disabled, canManage }: RunAnalysisButtonProps) {
  if (!canManage) {
    return null;
  }

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      buttonClassName={`px-4 py-2 text-sm font-medium rounded-md ${
        disabled
          ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
          : 'bg-purple-600 text-white hover:bg-purple-700'
      }`}
    >
      {disabled ? 'Analysis in progress…' : 'Run Analysis'}
    </Button>
  );
}
